/**
 * 暖棕摩卡模版独立页脚
 *
 * 设计理念：深可可棕底 + 焦糖顶线，三列排布（品牌 / 分类 / 快速入口）
 */

import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function MochaFooter() {
  const { siteName } = useSite();
  const { siteConfig, navMenus, navCategories } = useSiteConfig();

  const currentYear = new Date().getFullYear();
  const icp = siteConfig?.icp || "";

  return (
    <footer className="bg-[#3A2A1D] text-[#EADFCE]">
      {/* 顶部焦糖细线 */}
      <div className="h-1 bg-gradient-to-r from-[#C77B3F] via-[#DCA96B] to-[#C77B3F]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* 品牌区 */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="h-9 w-9 rounded-md bg-[#C77B3F]/20 border border-[#C77B3F]/40 flex items-center justify-center text-[#DCA96B] font-bold text-sm">
                {siteName ? siteName.charAt(0).toUpperCase() : 'S'}
              </div>
              <span className="text-lg font-bold text-[#F5EBDD]">{siteName}</span>
            </div>
            <p className="text-sm leading-relaxed text-[#C9B8A2]">
              分类信息服务平台，汇聚各类信息服务，为用户提供真实可靠的信息内容。
            </p>
          </div>

          {/* 分类导航 */}
          <div>
            <h4 className="text-sm font-bold text-[#F5EBDD] mb-4 tracking-wide">信息分类</h4>
            <div className="flex flex-wrap gap-x-5 gap-y-2.5">
              {navCategories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-[#C9B8A2] hover:text-[#DCA96B] transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
              {navMenus.map((menu) => (
                <Link
                  key={menu.id}
                  to={menu.type === 'category' ? `/category/${menu.target_url || ''}` :
                       menu.type === 'page' ? `/page/${menu.target_url || ''}` :
                       menu.type === 'link' ? (menu.target_url || '#') : '#'}
                  className="text-sm text-[#C9B8A2] hover:text-[#DCA96B] transition-colors"
                >
                  {menu.name}
                </Link>
              ))}
            </div>
          </div>

          {/* 快速入口 */}
          <div>
            <h4 className="text-sm font-bold text-[#F5EBDD] mb-4 tracking-wide">快速入口</h4>
            <div className="flex flex-col gap-2.5">
              <Link
                to="/publish"
                className="text-sm text-[#C9B8A2] hover:text-[#DCA96B] transition-colors flex items-center gap-2"
              >
                <i className="ri-add-circle-line" />发布信息
              </Link>
              <Link
                to="/login"
                className="text-sm text-[#C9B8A2] hover:text-[#DCA96B] transition-colors flex items-center gap-2"
              >
                <i className="ri-user-line" />用户登录
              </Link>
              <Link
                to="/register"
                className="text-sm text-[#C9B8A2] hover:text-[#DCA96B] transition-colors flex items-center gap-2"
              >
                <i className="ri-user-add-line" />注册账号
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* 底部版权条 */}
      <div className="border-t border-[#C77B3F]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-[#8A7B6D]">
            © {currentYear} {siteName} 版权所有
          </p>
          {icp && (
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-[#8A7B6D] hover:text-[#DCA96B] transition-colors"
            >
              {icp}
            </a>
          )}
        </div>
      </div>
    </footer>
  );
}
